import React from 'react';
import { Badge, IconButton, Tooltip } from '@mui/material';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';

import { BackgroundTaskContext } from './BackgroundTaskProvider';

const TaskNotificationBadge = ({ iconProps }) => {
    const { activeCount, setPopoverOpen, fetchRecentTasks } = React.useContext(BackgroundTaskContext);
    const anchorRef = React.useRef(null);

    const handleClick = () => {
        fetchRecentTasks();
        setPopoverOpen(true);
    };

    return (
        <Tooltip
            title={activeCount > 0 ? `${activeCount} background operation${activeCount > 1 ? 's' : ''} running` : 'Background operations'}
            PopperProps={{ style: { zIndex: 99999 } }}
        >
            <IconButton
                ref={anchorRef}
                onClick={handleClick}
                color="inherit"
                size="small"
                {...iconProps}
            >
                <Badge
                    badgeContent={activeCount}
                    color="primary"
                    invisible={activeCount === 0}
                    max={99}
                >
                    <AssignmentOutlinedIcon fontSize="small" />
                </Badge>
            </IconButton>
        </Tooltip>
    );
};

export default TaskNotificationBadge;
